// Mock farm data with coordinates for different product categories
// This simulates the restructured product system to represent farms with lat/long coordinates

export const mockFarms = [
  {
    id: 1,
    name: "Green Apple Farm",
    category: "green-apple",
    farmer_name: "John Smith",
    description: "Organic green apples grown in fertile valleys",
    coordinates: [151.2093, -33.8688], // Sydney, Australia
    location: "SYDNEY",
    area_m2: 5000,
    price_per_m2: 25,
    production_rate: 150,
    isPurchased: false,
    image: "/icons/products/fruits/apple_green.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "18.5°C :- partly cloudy",
    available_area: 120,
    total_area: 1000,
    harvest_date: "15 Mar, 2025"
  },
  {
    id: 2,
    name: "Red Apple Orchard",
    category: "red-apple",
    farmer_name: "Sarah Johnson",
    description: "Premium red apples with sweet flavor",
    coordinates: [144.9631, -37.8136], // Melbourne, Australia
    location: "MELBOURNE",
    area_m2: 7500,
    price_per_m2: 30,
    production_rate: 180,
    isPurchased: true,
    image: "/icons/products/fruits/apple_red.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "16.2°C :- light rain",
    available_area: 95,
    total_area: 1200,
    harvest_date: "20 Mar, 2025"
  },
  {
    id: 3,
    name: "Golden Corn Fields",
    category: "corn",
    farmer_name: "Mike Wilson",
    description: "High-yield corn production with modern techniques",
    coordinates: [153.0251, -27.4698], // Brisbane, Australia
    location: "BRISBANE",
    area_m2: 12000,
    price_per_m2: 15,
    production_rate: 200,
    isPurchased: false,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "24.8°C :- sunny",
    available_area: 250,
    total_area: 1800,
    harvest_date: "10 Apr, 2025"
  },
  {
    id: 4,
    name: "Purple Eggplant Garden",
    category: "eggplant",
    farmer_name: "Lisa Chen",
    description: "Fresh eggplants grown with sustainable methods",
    coordinates: [138.6007, -34.9285], // Adelaide, Australia
    location: "ADELAIDE",
    area_m2: 3000,
    price_per_m2: 35,
    production_rate: 120,
    isPurchased: true,
    image: "/icons/products/fruits/eggplant.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "19.3°C :- clear sky",
    available_area: 75,
    total_area: 600,
    harvest_date: "5 Feb, 2025"
  },
  {
    id: 5,
    name: "Sunny Lemon Grove",
    category: "lemon",
    farmer_name: "David Brown",
    description: "Citrus lemons with perfect acidity balance",
    coordinates: [115.8605, -31.9505], // Perth, Australia
    location: "PERTH",
    area_m2: 4500,
    price_per_m2: 40,
    production_rate: 160,
    isPurchased: false,
    image: "/icons/products/fruits/lemon.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "22.1°C :- sunny",
    available_area: 110,
    total_area: 900,
    harvest_date: "25 Jan, 2025"
  },
  {
    id: 6,
    name: "Sweet Peach Plantation",
    category: "peach",
    farmer_name: "Emma Davis",
    description: "Juicy peaches perfect for fresh consumption",
    coordinates: [147.3272, -42.8821], // Hobart, Australia
    location: "HOBART",
    area_m2: 6000,
    price_per_m2: 45,
    production_rate: 140,
    isPurchased: true,
    image: "/icons/products/fruits/peach.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "14.7°C :- overcast clouds",
    available_area: 85,
    total_area: 1100,
    harvest_date: "18 Dec, 2024"
  },
  {
    id: 7,
    name: "Berry Strawberry Fields",
    category: "strawberry",
    farmer_name: "Tom Anderson",
    description: "Premium strawberries grown in controlled environment",
    coordinates: [149.1300, -35.2809], // Canberra, Australia
    location: "CANBERRA",
    area_m2: 2500,
    price_per_m2: 60,
    production_rate: 100,
    isPurchased: false,
    image: "/icons/products/fruits/strawberry.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "12.4°C :- light snow",
    available_area: 60,
    total_area: 500,
    harvest_date: "30 Nov, 2024"
  },
  {
    id: 8,
    name: "Citrus Tangerine Farm",
    category: "tangerine",
    farmer_name: "Maria Garcia",
    description: "Sweet tangerines with vibrant orange color",
    coordinates: [130.8456, -12.4634], // Darwin, Australia
    location: "DARWIN",
    area_m2: 5500,
    price_per_m2: 38,
    production_rate: 170,
    isPurchased: true,
    image: "/icons/products/fruits/tangerine.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "28.9°C :- tropical storm",
    available_area: 130,
    total_area: 1000,
    harvest_date: "8 Feb, 2025"
  },
  {
    id: 9,
    name: "Red Tomato Greenhouse",
    category: "tomato",
    farmer_name: "Robert Taylor",
    description: "Greenhouse tomatoes with consistent quality",
    coordinates: [145.7781, -16.9186], // Cairns, Australia
    location: "CAIRNS",
    area_m2: 4000,
    price_per_m2: 50,
    production_rate: 190,
    isPurchased: false,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "26.3°C :- humid",
    available_area: 90,
    total_area: 800,
    harvest_date: "12 Jan, 2025"
  },
  {
    id: 10,
    name: "Giant Watermelon Farm",
    category: "watermelon",
    farmer_name: "Jennifer White",
    description: "Large watermelons perfect for summer season",
    coordinates: [121.4944, -25.2744], // Geraldton, Australia
    location: "GERALDTON",
    area_m2: 8000,
    price_per_m2: 20,
    production_rate: 130,
    isPurchased: true,
    image: "/icons/products/fruits/watermelon.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "20.6°C :- windy",
    available_area: 180,
    total_area: 1400,
    harvest_date: "22 Mar, 2025"
  },
  {
    id: 11,
    name: "California Almond Grove",
    category: "green-apple",
    farmer_name: "Carlos Rodriguez",
    description: "Premium almonds from Central Valley",
    coordinates: [-120.4179, 36.7783], // California, USA
    location: "FRESNO",
    area_m2: 9500,
    price_per_m2: 55,
    production_rate: 165,
    isPurchased: false,
    image: "/icons/products/fruits/apple_green.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "21.3°C :- sunny",
    available_area: 200,
    total_area: 1600,
    harvest_date: "15 Apr, 2025"
  },
  {
    id: 12,
    name: "Iowa Corn Valley",
    category: "corn",
    farmer_name: "Mark Thompson",
    description: "High-yield corn from America's heartland",
    coordinates: [-93.6091, 41.5868], // Iowa, USA
    location: "DES MOINES",
    area_m2: 15000,
    price_per_m2: 18,
    production_rate: 220,
    isPurchased: true,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "15.7°C :- partly cloudy",
    available_area: 300,
    total_area: 2200,
    harvest_date: "28 Sep, 2025"
  },
  {
    id: 13,
    name: "Florida Orange Grove",
    category: "tangerine",
    farmer_name: "Ana Martinez",
    description: "Sweet citrus fruits from sunny Florida",
    coordinates: [-81.3792, 28.5383], // Florida, USA
    location: "ORLANDO",
    area_m2: 7200,
    price_per_m2: 42,
    production_rate: 175,
    isPurchased: false,
    image: "/icons/products/fruits/tangerine.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "27.4°C :- humid",
    available_area: 145,
    total_area: 1300,
    harvest_date: "10 Dec, 2024"
  },
  {
    id: 14,
    name: "Washington Apple Orchard",
    category: "red-apple",
    farmer_name: "Steve Johnson",
    description: "Crisp apples from Pacific Northwest",
    coordinates: [-120.5015, 47.1629], // Washington, USA
    location: "YAKIMA",
    area_m2: 8500,
    price_per_m2: 32,
    production_rate: 185,
    isPurchased: true,
    image: "/icons/products/fruits/apple_red.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "12.8°C :- light rain",
    available_area: 170,
    total_area: 1500,
    harvest_date: "5 Oct, 2025"
  },
  {
    id: 15,
    name: "Georgia Peach Farm",
    category: "peach",
    farmer_name: "Betty Williams",
    description: "Juicy Georgia peaches with southern charm",
    coordinates: [-83.6431, 32.9866], // Georgia, USA
    location: "MACON",
    area_m2: 6800,
    price_per_m2: 48,
    production_rate: 155,
    isPurchased: false,
    image: "/icons/products/fruits/peach.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "24.1°C :- sunny",
    available_area: 125,
    total_area: 1200,
    harvest_date: "20 Jun, 2025"
  },
  {
    id: 16,
    name: "California Strawberry Fields",
    category: "strawberry",
    farmer_name: "Miguel Santos",
    description: "Premium strawberries from coastal California",
    coordinates: [-121.4944, 36.9741], // California, USA
    location: "SALINAS",
    area_m2: 3200,
    price_per_m2: 65,
    production_rate: 110,
    isPurchased: true,
    image: "/icons/products/fruits/strawberry.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "18.9°C :- foggy",
    available_area: 80,
    total_area: 650,
    harvest_date: "15 May, 2025"
  },
  {
    id: 17,
    name: "Quebec Apple Orchard",
    category: "green-apple",
    farmer_name: "Pierre Dubois",
    description: "Cold-climate apples from Canadian orchards",
    coordinates: [-71.2080, 46.8139], // Quebec, Canada
    location: "QUEBEC CITY",
    area_m2: 5800,
    price_per_m2: 28,
    production_rate: 140,
    isPurchased: false,
    image: "/icons/products/fruits/apple_green.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "8.2°C :- snow",
    available_area: 115,
    total_area: 1000,
    harvest_date: "25 Sep, 2025"
  },
  {
    id: 18,
    name: "Ontario Corn Fields",
    category: "corn",
    farmer_name: "Sarah MacDonald",
    description: "Sweet corn from fertile Ontario plains",
    coordinates: [-80.2482, 43.4643], // Ontario, Canada
    location: "LONDON",
    area_m2: 11000,
    price_per_m2: 16,
    production_rate: 195,
    isPurchased: true,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "11.5°C :- overcast",
    available_area: 220,
    total_area: 1900,
    harvest_date: "12 Aug, 2025"
  },
  {
    id: 19,
    name: "British Columbia Berry Farm",
    category: "strawberry",
    farmer_name: "James Chen",
    description: "Mountain strawberries with intense flavor",
    coordinates: [-123.1207, 49.2827], // British Columbia, Canada
    location: "VANCOUVER",
    area_m2: 2800,
    price_per_m2: 58,
    production_rate: 95,
    isPurchased: false,
    image: "/icons/products/fruits/strawberry.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "14.3°C :- drizzle",
    available_area: 70,
    total_area: 550,
    harvest_date: "8 Jul, 2025"
  },
  {
    id: 20,
    name: "Sao Paulo Coffee & Tomato",
    category: "tomato",
    farmer_name: "Ricardo Silva",
    description: "Tropical tomatoes from Brazilian highlands",
    coordinates: [-46.6333, -23.5505], // Sao Paulo, Brazil
    location: "SAO PAULO",
    area_m2: 4500,
    price_per_m2: 35,
    production_rate: 180,
    isPurchased: true,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "23.7°C :- tropical",
    available_area: 105,
    total_area: 900,
    harvest_date: "18 Feb, 2025"
  },
  {
    id: 21,
    name: "Argentine Corn Plains",
    category: "corn",
    farmer_name: "Diego Fernandez",
    description: "Large-scale corn production in Pampas",
    coordinates: [-58.3816, -34.6037], // Buenos Aires, Argentina
    location: "BUENOS AIRES",
    area_m2: 18000,
    price_per_m2: 12,
    production_rate: 240,
    isPurchased: false,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "19.8°C :- windy",
    available_area: 350,
    total_area: 2800,
    harvest_date: "22 Apr, 2025"
  },
  {
    id: 22,
    name: "Chilean Apple Valley",
    category: "red-apple",
    farmer_name: "Carmen Morales",
    description: "Export-quality apples from Andes foothills",
    coordinates: [-70.6693, -33.4489], // Santiago, Chile
    location: "SANTIAGO",
    area_m2: 7800,
    price_per_m2: 34,
    production_rate: 170,
    isPurchased: true,
    image: "/icons/products/fruits/apple_red.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "16.4°C :- clear",
    available_area: 155,
    total_area: 1400,
    harvest_date: "30 Mar, 2025"
  },
  {
    id: 23,
    name: "French Provence Tomatoes",
    category: "tomato",
    farmer_name: "Jean-Luc Moreau",
    description: "Mediterranean tomatoes with rich flavor",
    coordinates: [5.3698, 43.2965], // Marseille, France
    location: "MARSEILLE",
    area_m2: 3800,
    price_per_m2: 52,
    production_rate: 160,
    isPurchased: false,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "20.1°C :- sunny",
    available_area: 95,
    total_area: 750,
    harvest_date: "25 Jun, 2025"
  },
  {
    id: 24,
    name: "Italian Lemon Grove",
    category: "lemon",
    farmer_name: "Giuseppe Romano",
    description: "Sicilian lemons with authentic Mediterranean taste",
    coordinates: [15.0870, 37.5079], // Sicily, Italy
    location: "CATANIA",
    area_m2: 5200,
    price_per_m2: 45,
    production_rate: 150,
    isPurchased: true,
    image: "/icons/products/fruits/lemon.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "22.8°C :- Mediterranean",
    available_area: 120,
    total_area: 950,
    harvest_date: "14 Jan, 2025"
  },
  {
    id: 25,
    name: "Spanish Strawberry Fields",
    category: "strawberry",
    farmer_name: "Isabella Garcia",
    description: "Early season strawberries from Andalusia",
    coordinates: [-4.4214, 36.7213], // Malaga, Spain
    location: "MALAGA",
    area_m2: 3500,
    price_per_m2: 62,
    production_rate: 105,
    isPurchased: false,
    image: "/icons/products/fruits/strawberry.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "24.6°C :- warm",
    available_area: 85,
    total_area: 700,
    harvest_date: "10 Mar, 2025"
  },
  {
    id: 26,
    name: "German Apple Orchards",
    category: "green-apple",
    farmer_name: "Klaus Mueller",
    description: "Traditional German apples from Rhine Valley",
    coordinates: [8.2472, 50.0782], // Frankfurt, Germany
    location: "FRANKFURT",
    area_m2: 6200,
    price_per_m2: 36,
    production_rate: 145,
    isPurchased: true,
    image: "/icons/products/fruits/apple_green.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "13.7°C :- cloudy",
    available_area: 125,
    total_area: 1100,
    harvest_date: "18 Sep, 2025"
  },
  {
    id: 27,
    name: "Dutch Greenhouse Tomatoes",
    category: "tomato",
    farmer_name: "Pieter van Berg",
    description: "High-tech greenhouse tomatoes from Netherlands",
    coordinates: [4.9041, 52.3676], // Amsterdam, Netherlands
    location: "AMSTERDAM",
    area_m2: 4200,
    price_per_m2: 58,
    production_rate: 200,
    isPurchased: false,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "12.1°C :- rainy",
    available_area: 100,
    total_area: 800,
    harvest_date: "5 May, 2025"
  },
  {
    id: 28,
    name: "Polish Apple Farm",
    category: "red-apple",
    farmer_name: "Anna Kowalski",
    description: "Cold-resistant apples from Eastern Europe",
    coordinates: [21.0122, 52.2297], // Warsaw, Poland
    location: "WARSAW",
    area_m2: 7000,
    price_per_m2: 24,
    production_rate: 135,
    isPurchased: true,
    image: "/icons/products/fruits/apple_red.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "9.3°C :- frost",
    available_area: 140,
    total_area: 1250,
    harvest_date: "28 Sep, 2025"
  },
  {
    id: 29,
    name: "Turkish Eggplant Gardens",
    category: "eggplant",
    farmer_name: "Mehmet Ozkan",
    description: "Traditional eggplants from Anatolian plains",
    coordinates: [32.8597, 39.9334], // Ankara, Turkey
    location: "ANKARA",
    area_m2: 3600,
    price_per_m2: 32,
    production_rate: 125,
    isPurchased: false,
    image: "/icons/products/fruits/eggplant.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "17.9°C :- dry",
    available_area: 90,
    total_area: 720,
    harvest_date: "12 Jul, 2025"
  },
  {
    id: 30,
    name: "Indian Watermelon Fields",
    category: "watermelon",
    farmer_name: "Raj Patel",
    description: "Sweet watermelons from Punjab plains",
    coordinates: [75.3412, 31.1471], // Punjab, India
    location: "LUDHIANA",
    area_m2: 9200,
    price_per_m2: 18,
    production_rate: 175,
    isPurchased: true,
    image: "/icons/products/fruits/watermelon.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "29.4°C :- hot",
    available_area: 190,
    total_area: 1600,
    harvest_date: "8 May, 2025"
  },
  {
    id: 31,
    name: "Chinese Corn Valleys",
    category: "corn",
    farmer_name: "Li Wei",
    description: "High-yield corn from Northeast China",
    coordinates: [125.3245, 43.8171], // Changchun, China
    location: "CHANGCHUN",
    area_m2: 14500,
    price_per_m2: 14,
    production_rate: 210,
    isPurchased: false,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "6.8°C :- cold",
    available_area: 280,
    total_area: 2300,
    harvest_date: "15 Oct, 2025"
  },
  {
    id: 32,
    name: "Japanese Strawberry Farm",
    category: "strawberry",
    farmer_name: "Hiroshi Tanaka",
    description: "Premium strawberries with perfect sweetness",
    coordinates: [139.6917, 35.6895], // Tokyo, Japan
    location: "TOKYO",
    area_m2: 2200,
    price_per_m2: 85,
    production_rate: 80,
    isPurchased: true,
    image: "/icons/products/fruits/strawberry.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "16.2°C :- mild",
    available_area: 55,
    total_area: 450,
    harvest_date: "20 Apr, 2025"
  },
  {
    id: 33,
    name: "Thai Eggplant Gardens",
    category: "eggplant",
    farmer_name: "Somchai Prasert",
    description: "Tropical eggplants from Thai highlands",
    coordinates: [100.5018, 13.7563], // Bangkok, Thailand
    location: "BANGKOK",
    area_m2: 3200,
    price_per_m2: 28,
    production_rate: 140,
    isPurchased: false,
    image: "/icons/products/fruits/eggplant.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "31.2°C :- tropical humid",
    available_area: 80,
    total_area: 640,
    harvest_date: "25 Mar, 2025"
  },
  {
    id: 34,
    name: "Vietnamese Tomato Farms",
    category: "tomato",
    farmer_name: "Nguyen Van Duc",
    description: "Fresh tomatoes from Mekong Delta",
    coordinates: [106.6297, 10.8231], // Ho Chi Minh City, Vietnam
    location: "HO CHI MINH",
    area_m2: 4800,
    price_per_m2: 22,
    production_rate: 165,
    isPurchased: true,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "28.7°C :- monsoon",
    available_area: 115,
    total_area: 960,
    harvest_date: "30 Jan, 2025"
  },
  {
    id: 35,
    name: "South African Corn Fields",
    category: "corn",
    farmer_name: "Thabo Mthembu",
    description: "Drought-resistant corn from African plains",
    coordinates: [28.0473, -26.2041], // Johannesburg, South Africa
    location: "JOHANNESBURG",
    area_m2: 13200,
    price_per_m2: 10,
    production_rate: 185,
    isPurchased: false,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "21.5°C :- savanna",
    available_area: 260,
    total_area: 2100,
    harvest_date: "18 Jun, 2025"
  },
  {
    id: 36,
    name: "Moroccan Citrus Grove",
    category: "tangerine",
    farmer_name: "Omar Benali",
    description: "Sweet citrus fruits from Atlas Mountains",
    coordinates: [-7.5898, 33.9716], // Casablanca, Morocco
    location: "CASABLANCA",
    area_m2: 6500,
    price_per_m2: 36,
    production_rate: 155,
    isPurchased: true,
    image: "/icons/products/fruits/tangerine.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "22.3°C :- Mediterranean",
    available_area: 130,
    total_area: 1150,
    harvest_date: "5 Feb, 2025"
  },
  {
    id: 37,
    name: "Egyptian Watermelon Oasis",
    category: "watermelon",
    farmer_name: "Ahmed Hassan",
    description: "Desert watermelons with intense sweetness",
    coordinates: [31.2357, 30.0444], // Cairo, Egypt
    location: "CAIRO",
    area_m2: 7800,
    price_per_m2: 25,
    production_rate: 145,
    isPurchased: false,
    image: "/icons/products/fruits/watermelon.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "26.8°C :- arid",
    available_area: 155,
    total_area: 1300,
    harvest_date: "12 Apr, 2025"
  },
  {
    id: 38,
    name: "Kenyan Tomato Highlands",
    category: "tomato",
    farmer_name: "Grace Wanjiku",
    description: "High-altitude tomatoes with rich flavor",
    coordinates: [36.8219, -1.2921], // Nairobi, Kenya
    location: "NAIROBI",
    area_m2: 4100,
    price_per_m2: 30,
    production_rate: 150,
    isPurchased: true,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "19.6°C :- equatorial",
    available_area: 100,
    total_area: 820,
    harvest_date: "22 Feb, 2025"
  },
  {
    id: 39,
    name: "New Zealand Apple Orchards",
    category: "green-apple",
    farmer_name: "Michael O'Connor",
    description: "Crisp apples from Canterbury plains",
    coordinates: [172.6362, -43.5321], // Christchurch, New Zealand
    location: "CHRISTCHURCH",
    area_m2: 6800,
    price_per_m2: 38,
    production_rate: 160,
    isPurchased: false,
    image: "/icons/products/fruits/apple_green.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "14.2°C :- temperate",
    available_area: 135,
    total_area: 1200,
    harvest_date: "8 Apr, 2025"
  },
  {
    id: 40,
    name: "Fiji Tropical Fruits",
    category: "peach",
    farmer_name: "Ratu Seru",
    description: "Tropical stone fruits from Pacific islands",
    coordinates: [178.4419, -18.1248], // Suva, Fiji
    location: "SUVA",
    area_m2: 3800,
    price_per_m2: 55,
    production_rate: 120,
    isPurchased: true,
    image: "/icons/products/fruits/peach.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "25.9°C :- tropical",
    available_area: 95,
    total_area: 760,
    harvest_date: "15 Jan, 2025"
  },
  {
    id: 41,
    name: "Russian Wheat & Corn",
    category: "corn",
    farmer_name: "Dmitri Volkov",
    description: "Hardy grains from Siberian steppes",
    coordinates: [82.9346, 55.0084], // Novosibirsk, Russia
    location: "NOVOSIBIRSK",
    area_m2: 16800,
    price_per_m2: 8,
    production_rate: 190,
    isPurchased: false,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "2.1°C :- continental",
    available_area: 320,
    total_area: 2600,
    harvest_date: "25 Aug, 2025"
  },
  {
    id: 42,
    name: "Norwegian Greenhouse Tomatoes",
    category: "tomato",
    farmer_name: "Erik Andersen",
    description: "Sustainable greenhouse production in Arctic",
    coordinates: [10.7522, 59.9139], // Oslo, Norway
    location: "OSLO",
    area_m2: 2800,
    price_per_m2: 75,
    production_rate: 130,
    isPurchased: true,
    image: "/icons/products/fruits/tomato.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "7.4°C :- Nordic",
    available_area: 70,
    total_area: 560,
    harvest_date: "10 Jul, 2025"
  },
  {
    id: 43,
    name: "Mexican Avocado & Lemon",
    category: "lemon",
    farmer_name: "Carlos Mendoza",
    description: "Citrus fruits from volcanic soil",
    coordinates: [-99.1332, 19.4326], // Mexico City, Mexico
    location: "MEXICO CITY",
    area_m2: 5600,
    price_per_m2: 42,
    production_rate: 165,
    isPurchased: false,
    image: "/icons/products/fruits/lemon.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "20.7°C :- highland",
    available_area: 140,
    total_area: 1120,
    harvest_date: "28 Feb, 2025"
  },
  {
    id: 44,
    name: "Colombian Coffee & Peach",
    category: "peach",
    farmer_name: "Maria Gonzalez",
    description: "High-altitude stone fruits from Andes",
    coordinates: [-74.0721, 4.7110], // Bogota, Colombia
    location: "BOGOTA",
    area_m2: 4200,
    price_per_m2: 48,
    production_rate: 135,
    isPurchased: true,
    image: "/icons/products/fruits/peach.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "15.8°C :- mountain",
    available_area: 105,
    total_area: 840,
    harvest_date: "18 Mar, 2025"
  },
  {
    id: 45,
    name: "Israeli Desert Agriculture",
    category: "eggplant",
    farmer_name: "David Cohen",
    description: "Innovative desert farming techniques",
    coordinates: [34.7818, 32.0853], // Tel Aviv, Israel
    location: "TEL AVIV",
    area_m2: 3400,
    price_per_m2: 65,
    production_rate: 155,
    isPurchased: false,
    image: "/icons/products/fruits/eggplant.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "23.5°C :- Mediterranean desert",
    available_area: 85,
    total_area: 680,
    harvest_date: "5 Apr, 2025"
  },
  {
    id: 46,
    name: "Ukrainian Sunflower & Corn",
    category: "corn",
    farmer_name: "Oksana Petrenko",
    description: "Black soil agriculture from Eastern Europe",
    coordinates: [30.5234, 50.4501], // Kiev, Ukraine
    location: "KIEV",
    area_m2: 12500,
    price_per_m2: 15,
    production_rate: 205,
    isPurchased: true,
    image: "/icons/products/fruits/corn.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "10.6°C :- continental",
    available_area: 250,
    total_area: 2000,
    harvest_date: "12 Sep, 2025"
  },
  {
    id: 47,
    name: "Greek Island Citrus",
    category: "lemon",
    farmer_name: "Nikos Papadopoulos",
    description: "Mediterranean lemons from Greek islands",
    coordinates: [23.7275, 37.9838], // Athens, Greece
    location: "ATHENS",
    area_m2: 4800,
    price_per_m2: 44,
    production_rate: 148,
    isPurchased: false,
    image: "/icons/products/fruits/lemon.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "21.4°C :- Mediterranean",
    available_area: 120,
    total_area: 960,
    harvest_date: "20 Jan, 2025"
  },
  {
    id: 48,
    name: "Swedish Greenhouse Strawberries",
    category: "strawberry",
    farmer_name: "Astrid Larsson",
    description: "Year-round strawberry production in Nordic climate",
    coordinates: [18.0686, 59.3293], // Stockholm, Sweden
    location: "STOCKHOLM",
    area_m2: 2600,
    price_per_m2: 78,
    production_rate: 90,
    isPurchased: true,
    image: "/icons/products/fruits/strawberry.png",
    shipping_pickup: false,
    shipping_delivery: true,
    weather: "8.9°C :- Nordic",
    available_area: 65,
    total_area: 520,
    harvest_date: "15 Jun, 2025"
  },
  {
    id: 49,
    name: "Peruvian Highland Potatoes",
    category: "eggplant",
    farmer_name: "Carlos Quispe",
    description: "High-altitude vegetables from Andes mountains",
    coordinates: [-77.0428, -12.0464], // Lima, Peru
    location: "LIMA",
    area_m2: 3900,
    price_per_m2: 38,
    production_rate: 142,
    isPurchased: false,
    image: "/icons/products/fruits/eggplant.png",
    shipping_pickup: true,
    shipping_delivery: false,
    weather: "18.3°C :- coastal desert",
    available_area: 98,
    total_area: 780,
    harvest_date: "8 May, 2025"
  },
  {
    id: 50,
    name: "Australian Tropical Mangoes",
    category: "watermelon",
    farmer_name: "Bruce Mitchell",
    description: "Tropical fruits from Northern Australia",
    coordinates: [130.8456, -12.4634], // Darwin, Australia
    location: "DARWIN",
    area_m2: 8500,
    price_per_m2: 32,
    production_rate: 168,
    isPurchased: true,
    image: "/icons/products/fruits/watermelon.png",
    shipping_pickup: true,
    shipping_delivery: true,
    weather: "29.1°C :- tropical monsoon",
    available_area: 180,
    total_area: 1400,
    harvest_date: "22 Mar, 2025"
  }
];

// Helper function to get farms by purchase status
export const getPurchasedFarms = () => mockFarms.filter(farm => farm.isPurchased);
export const getAvailableFarms = () => mockFarms.filter(farm => !farm.isPurchased);

// Helper function to get farms by category
export const getFarmsByCategory = (category) => mockFarms.filter(farm => farm.category === category);

// Helper function to toggle purchase status
export const toggleFarmPurchase = (farmId) => {
  const farm = mockFarms.find(f => f.id === farmId);
  if (farm) {
    farm.isPurchased = !farm.isPurchased;
  }
  return farm;
};